import {useEffect, useState} from 'react';

import {Conversation} from '@stripe-internal/conversations-client';

import {
  isChannelChat,
  isChannelRAC,
} from '../../../core/lib/util/conversationUtils';
import {useConversationEnded} from './useConversationEnded';

export function useLiveChannelStatus(conversation: Conversation) {
  const [isChat, setIsChat] = useState<boolean>(false);
  const [isRAC, setIsRAC] = useState<boolean>(false);

  const conversationEnded = useConversationEnded(conversation);

  useEffect(() => {
    setIsChat(isChannelChat(conversation));
    setIsRAC(isChannelRAC(conversation));

    const sub = conversation.contextObservable().subscribe(() => {
      setIsChat(isChannelChat(conversation));
      setIsRAC(isChannelRAC(conversation));
    });

    return () => sub.unsubscribe();
  }, [conversation]);

  return {
    isLiveChatActive: isChat && !conversationEnded,
    isRACActive: isRAC && !conversationEnded,
  };
}
